import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import BlogPost from './components/BlogPost';
import PostList from './components/PostList';
import AboutMe from './components/AboutMe';
import TermsOfUse from './components/TermsOfUse';
import EditPost from './components/admin/EditPost';
import CategoryPage from './components/CategoryPage';
import SubcategoryPage from './components/SubcategoryPage';
import './App.css';

const App = () => {
  // Check if current path is admin route
  const isAdminRoute = window.location.pathname.startsWith('/admin');

  // Protected Admin Route component
  const ProtectedAdminRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={props => {
        // Check authentication dynamically when route is accessed
        const isAdminLoggedIn = localStorage.getItem('adminToken');
        return isAdminLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/admin/login",
              state: { from: props.location }
            }}
          />
        );
      }}
    />
  );

  return (
    <Router>
      <div className="app">
        {/* Only show Navigation and Footer on public routes */}
        {!isAdminRoute && <Navigation />}
        
        <main className={isAdminRoute ? 'admin-layout' : 'main-content'}>
          <Switch>
            {/* Admin Login Route - Always accessible */}
            <Route exact path="/admin/login" component={AdminLogin} />
            
            {/* Protected Admin Routes - Only accessible when authenticated */}
            <ProtectedAdminRoute path="/admin/posts/edit/:id" component={EditPost} />
            <ProtectedAdminRoute path="/admin" component={AdminDashboard} />

            {/* Public Routes */}
            <Route exact path="/" component={PostList} />
            <Route exact path="/post/:id" component={BlogPost} />
            <Route exact path="/o-meni" component={AboutMe} />
            <Route exact path="/pravila-koriscenja" component={TermsOfUse} />
            <Route exact path="/category/:categoryId" component={CategoryPage} />
            <Route exact path="/category/:categoryId/:subcategoryId" component={SubcategoryPage} />

            {/* Catch all route - redirect to home */}
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </main>
        
        {!isAdminRoute && <Footer />}
      </div>
    </Router>
  );
};

export default App;
